import AuthService from "../services/auth.service";
const user = JSON.parse(localStorage.getItem("user"));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    //Login the User
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    /**
     * user : contains the refreshToken to get the longterm one
     */
    loginSSO({ commit }, user) {
      return AuthService.loginSSO(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    loginSimulateSSO({ commit }, userData) {
      return AuthService.loginSimulateSSO(userData).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    //Login the User with Microsoft account
    loginMicrosoft({ commit }, user) {
      return AuthService.loginMicrosoft(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    loginStudent({ commit }, user) {
      return AuthService.loginStudent(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    },

    //Register the User
    register({ commit }, user) {
      return AuthService.register(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },

    //Register the User with Microsoft account
    registerMicrosoft({ commit }, user) {
      return AuthService.registerMicrosoft(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },

    registerStudent({ commit }, user) {
      return AuthService.registerStudent(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },

    forgetPassword({ commit }, user) {
      return AuthService.forgetPassword(user).then(
        (response) => {
          commit("forgetPasswordSuccess");
          return Promise.resolve(response);
        },
        (error) => {
          commit("forgetPasswordFailure");
          return Promise.reject(error);
        }
      );
    },
    changePassword({ commit }, user) {
      return AuthService.changePassword(user).then(
        (response) => {
          commit("changePasswordSuccess");
          return Promise.resolve(response);
        },
        (error) => {
          commit("changePasswordFailure");
          return Promise.reject(error);
        }
      );
    },
  },

  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
  },
};
